import { useMutation } from "@apollo/client";
import { gql } from "@src/__generated__";

const CREATE_DOCUMENT = gql(`
  mutation CreateDocument($input: CreateDocumentInput!) {
    createDocument(input: $input) {
      ...DocumentFields
    }
  }
`);

export function useCreateDocument() {
  const [createDocument] = useMutation(CREATE_DOCUMENT);

  return {
    createDocument,
  };
}
